import React from "react";
import BaseComponent from "../BaseComponent";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex.js";
import { getByPath } from "../Global/tools.js";

import Button from "../Nano/Buttons/Button.js";
import Type from "../Global/Typography.js";

//IMAGES
import { ReactComponent as AdvancedSearchIcon } from "../Global/Icons/advancedSearch.svg";
import { ReactComponent as Delete } from "../Global/Icons/close.svg";

const multiple = nota.global.multiple;

const RecapFiltersModalStyle = styled.div`
  width: 450px;
  background-color: ${nota.color.neutral.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  /* padding: ${multiple * 3 + "px"}; */
  .headerModal {
    background: ${nota.color.neutral.NeuFour};
    padding: ${multiple * 3 + "px"};
    svg {
      width: auto;
      height: 28px;
      path {
        fill: ${nota.color.neutral.NeuOne};
      }
      .gear {
        fill: ${nota.color.main.mOne};
      }
    }
  }
  .recapFiltersContainer {
    padding: ${multiple * 3 + "px"};
    min-height: 300px;
    max-height: 500px;
    overflow: auto;
    .recapFiltersListWrapper {
      .recapItemList {
        border-bottom: 1px solid ${nota.color.neutral.NeuFour};
        padding-bottom: ${multiple + "px"};
        margin-bottom: ${multiple + "px"};
        .titleWrapper {
          height: auto;
          width: auto;
          p {
            font-weight: bold;
            color: ${nota.color.main.mOne};
          }
          .deleteInfo {
            width: auto;
            margin-left: 4px;
            margin-top: 2px;
            background: ${nota.color.neutral.NeuFour};
            padding: 4px;
            border-radius: 20px;
            cursor: pointer;
            svg {
              width: auto;
              height: 8px;
              path {
                fill: ${nota.color.neutral.NeuTwo};
              }
            }
            &:hover {
              svg {
                path {
                  fill: ${nota.color.main.mTwo};
                }
              }
            }
          }
        }
        .highlightsList {
          .highlightContainer {
            width: auto;
            .highlightWrapper {
              padding: 4px 8px 4px 0;

              .highlightInfo {
                margin-top: ${multiple + "px"};
                margin-left: ${multiple * 2 + "px"};
              }
              .nivel2 {
                margin-top: ${multiple + "px"};
                margin-left: ${multiple * 4 + "px"};
              }
            }
          }
        }
        &:last-child {
          border-bottom: 0;
        }
      }
      .noItems {
        background-color: ${nota.color.neutral.NeuFour};
        height: 252px;
        p {
          text-transform: uppercase;
        }
      }
    }
  }
  .simpleBtnWrapper {
    background: ${nota.color.neutral.lightGrey};
    div {
      width: 100%;
      text-align: center;
      .cta {
        padding: ${multiple + "px"};
        width: 100%;
        min-width: 100%;
        max-width: 100%;
        &:hover {
          color: ${nota.color.main.mTwo};
        }
      }
    }
  }
  .btnsContainer {
    padding: 16px 8px;
    border-top: 0.5px solid ${nota.color.neutral.NeuFour};
    .cta {
      margin: 0;
    }
  }

  @media only screen and (max-width: ${nota.global.breakpoints.tablet + "px"}) {
    .recapFiltersContainer {
      max-height: 400px;
    }
  }
  @media only screen and (max-width: 500px) {
    width: 90vw;
    .btnsContainer {
      flex-direction: column;
      .buttonWrapper {
        order: 1;
      }
      .simpleButtonWrapper {
        order: 2;
        margin-top: ${multiple + "px"};
      }
    }
  }
`;

class RecapFiltersModal extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = this.getDefaultState();

    this.contentRef = React.createRef();
  }

  getDefaultState = () => {
    return {
      deletedFilters: [],
    };
  };

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  deleteFilter = (item) => {
    this.setState({ deletedFilters: [...this.state.deletedFilters, item] });
  };

  cancelClick = () => {
    this.setState(this.getDefaultState(), () => {
      this.contentRef.current.scrollTo({ top: 0, behavior: "auto" });
      this.props.cancelAction();
    });
  };

  confirmClick = () => {
    if (this.state.deletedFilters.length > 0) {
      window.dispatchEvent(new CustomEvent("deleteFilter", { detail: this.state.deletedFilters }));
    }

    this.setState(this.getDefaultState(), () => {
      this.contentRef.current.scrollTo({ top: 0, behavior: "auto" });
      this.props.nextAction();
    });
  };

  onClearClick = () => {
    window.dispatchEvent(new CustomEvent("clearSearch", { detail: { searchFrom: "AdvancedSearch" } }));
  };

  render() {
    let filteredResults = this.props.recapFilters.filter((item) => {
      return this.state.deletedFilters.includes(item) == false;
    });

    return (
      <RecapFiltersModalStyle>
        <NanoFlex className="headerModal">
          <AdvancedSearchIcon />
        </NanoFlex>

        <NanoFlex ref={this.contentRef} className="recapFiltersContainer" alignItems="flex-start">
          <NanoFlex className="recapFiltersListWrapper" flexDirection="column" justifyContent="flex-start">
            {/* RECAP ITEM */}
            {filteredResults.map((item) => {
              return (
                <NanoFlex key={item.field} className="recapItemList" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                  <NanoFlex className="titleWrapper" justifyContent="flex-start">
                    <Type.p>
                      <b>{getByPath(item.translation, this.translation)}</b>
                    </Type.p>
                    <NanoFlex
                      className="deleteInfo"
                      onClick={() => {
                        this.deleteFilter(item);
                      }}>
                      <Delete />
                    </NanoFlex>
                  </NanoFlex>

                  <NanoFlex className="highlightsList" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                    {/* HIGHLIGHT CONTAINER */}
                    {item.values.map((val) => {
                      return (
                        <NanoFlex className="highlightContainer" justifyContent="flex-start" key={val.id ?? val.name}>
                          <NanoFlex className="highlightWrapper" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                            <Type.p className="highlightInfo">
                              <b>{val.name}</b>
                            </Type.p>
                            {val.childs &&
                              val.childs.map((child) => {
                                return (
                                  <Type.p className="highlightInfo nivel2" key={child.id ?? child.name}>
                                    {child.name}
                                  </Type.p>
                                );
                              })}
                          </NanoFlex>
                        </NanoFlex>
                      );
                    })}
                    {/* END HIGHLIGHT CONTAINER */}
                  </NanoFlex>
                </NanoFlex>
              );
            })}

            {filteredResults.length === 0 && (
              <NanoFlex className="noItems">
                <Type.p>No Filters</Type.p>
              </NanoFlex>
            )}
            {/* END RECAP ITEM */}
          </NanoFlex>
        </NanoFlex>
        <NanoFlex className="simpleBtnWrapper">
          <Button label={this.translation.advancedSearch.clearAll} simple clickAction={this.onClearClick} />
        </NanoFlex>
        <NanoFlex className="btnsContainer" alignContent={"flex-end"}>
          <Button label={this.translation.geral.cancel} simple clickAction={this.cancelClick} />
          <Button label={this.translation.geral.confirm} clickAction={this.confirmClick} />
        </NanoFlex>
      </RecapFiltersModalStyle>
    );
  }
}

// Set default props
RecapFiltersModal.defaultProps = {
  cancelAction: () => null,
  nextAction: () => null,
};

export default RecapFiltersModal;

/*
Doc
import RecapFiltersModal from '../../Micro/RecapFiltersModal.js';

<RecapFiltersModal>
    cancelAction={() => console.log('cancelAction')}
</RecapFiltersModal>
*/
